import {defineStore, type StoreDefinition} from 'pinia';
import {state, type LearningStoreState} from "@/store/learning/state";
import {getters, type LearningStoreGetters} from "@/store/learning/getters";
import {actions, type LearningStoreActions} from "@/store/learning/actions";

export type LearningStoreType = StoreDefinition<string, LearningStoreState, LearningStoreGetters, LearningStoreActions>;

const useLearningStoreBase: LearningStoreType = defineStore('learningStore', {
    state,
    getters,
    actions
});

export const useLearningStore: LearningStoreType = useLearningStoreBase;
